import { NgModule } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
// libs
import { TranslateModule } from "@ngx-translate/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { UISharedModule } from "@mypxplat/xplat/features";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FileUploadModule } from "ng2-file-upload";
import { RoundProgressModule } from "angular-svg-round-progressbar";
import { ImageCropperModule } from "ngx-img-cropper";
import { RecaptchaModule } from "ng-recaptcha";
import { CookieService } from "ngx-cookie-service";
import { GoogleMapsModule } from "@angular/google-maps";
import { AngularDraggableModule } from "angular2-draggable";
import { ClipboardModule } from "ngx-clipboard";
import { UI_COMPONENTS } from "./components";
import { MODALS_COMPONENTS } from "./components";
import { UI_DIRECTIVES } from "./directives";
import { environment } from "@mypxplat/xplat/core";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { MentionModule } from "angular-mentions";
import { YouTubePlayerModule } from "@angular/youtube-player";
import { DragulaModule } from "ng2-dragula";
import { FontAwesomeModule, FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { MaskitoDirective } from "@maskito/angular";
import { QuillModule } from "ngx-quill";
import { QuillConfigModule } from "ngx-quill/config";
import { A11yModule } from "@angular/cdk/a11y";
import {
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faSpinner,
  faPlusSquare,
  faCheck,
  faTimes,
  faPhotoVideo,
  faSync,
  faUserCheck,
  faDownload,
  faExclamationCircle,
  faArrowLeft,
  faUser,
  faSearch,
  faCloudDownloadAlt,
  faEdit,
  faPaperclip,
  faPaperPlane,
  faFileAudio,
  faFileArchive,
  faStop,
  faMinus,
  faStar,
  faScrewdriverWrench,
  faCheckCircle,
  faTimesCircle,
  faPencilAlt,
  faFolderOpen,
  faFile,
  faBars,
  faWandMagicSparkles,
  faHome,
  faExternalLinkAlt,
  faCaretDown,
  faAppleAlt,
  faKey,
  faWrench,
  faUsers,
  faExclamationTriangle,
  faCog,
  faShoppingCart,
  faCloud,
  faQuestion,
  faFilter,
  faBook,
  faExpand,
  faPlay,
  faPlayCircle,
  faStopCircle,
  faExternalLinkSquareAlt,
  faInfoCircle,
  faPause,
  faLink,
  faThumbsUp,
  faInfo,
  faVideo,
  faFolder,
  faClock,
  faArrowAltCircleUp,
  faPlus,
  faImage,
  faFileImage,
  faComment,
  faComments,
  faTrash,
  faReply,
  faTrashAlt,
  faPlusCircle,
  faEllipsisH,
  faEnvelope,
  faBullhorn,
  faGuitar,
  faMicrophone,
  faBell,
  faThumbtack,
  faCompress,
  faHashtag,
  faVideoSlash,
  faGraduationCap,
  faCalendar,
  faTableCellsLarge,
  faArrowAltCircleDown,
  faMusic,
  faSun,
  faVolumeMute,
  faVolumeUp,
  faMoon,
  faStickyNote,
  faNewspaper,
  faCircle,
  faCheckSquare,
  faEye,
  faEyeSlash,
  faArrowUpRightFromSquare,
  faTh,
  faListUl,
  faArrowUp,
  faArrowDown,
  faLock,
  faCopy,
  faExternalLink,
  faTicket,
  faHeart,
  faBug,
  faQuestionCircle,
  faLayerGroup,
  faRightFromBracket,
  faArrowRotateLeft,
  faEgg,
  faArrowsRotate,
  faBan,
} from "@fortawesome/free-solid-svg-icons";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";

import { faWindows, faApple, faLinux } from "@fortawesome/free-brands-svg-icons";
const MODULES = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  UISharedModule,
  NgxSpinnerModule,
  NgbModule,
  AngularDraggableModule,
  FileUploadModule,
  RoundProgressModule,
  RecaptchaModule,
  FontAwesomeModule,
  ImageCropperModule,
  AngularFirestoreModule,
  AngularFireAuthModule,
  AngularFireMessagingModule,
  ClipboardModule,
  YouTubePlayerModule,
  MentionModule,
  A11yModule,
];

@NgModule({
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    ...MODULES,
    DragulaModule.forRoot(),
    GoogleMapsModule,
    MaskitoDirective,
    RecaptchaV3Module,
    QuillModule.forRoot(),
    QuillConfigModule.forRoot({
      modules: {
        toolbar: [["bold", "italic", "underline", "strike"]],
      },
    }),
  ],
  declarations: [...UI_COMPONENTS, ...UI_DIRECTIVES],
  providers: [CookieService, CurrencyPipe, { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaV3Key }],
  exports: [...MODULES, ...UI_COMPONENTS, ...UI_DIRECTIVES, MaskitoDirective],
})
export class UIModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faChevronRight,
      faChevronLeft,
      faChevronDown,
      faChevronUp,
      faSpinner,
      faPlusSquare,
      faPlus,
      faCheck,
      faTimes,
      faSync,
      faDownload,
      faCloudDownloadAlt,
      faExclamationCircle,
      faArrowLeft,
      faUser,
      faScrewdriverWrench,
      faEdit,
      faTableCellsLarge,
      faUserCheck,
      faPaperclip,
      faPaperPlane,
      faVideoSlash,
      faFileAudio,
      faHeart,
      faFileArchive,
      faStop,
      faMinus,
      faStar,
      faBell,
      faCheckCircle,
      faTimesCircle,
      faPencilAlt,
      faFolderOpen,
      faFile,
      faNewspaper,
      faBars,
      faExternalLinkAlt,
      faCaretDown,
      faAppleAlt,
      faKey,
      faHashtag,
      faComment,
      faComments,
      faBullhorn,
      faVolumeMute,
      faVolumeUp,
      faCompress,
      faFilter,
      faExpand,
      faGuitar,
      faMicrophone,
      faWrench,
      faMusic,
      faWandMagicSparkles,
      faUsers,
      faExclamationTriangle,
      faCog,
      faShoppingCart,
      faCloud,
      faQuestion,
      faBook,
      faExpand,
      faPlay,
      faPlayCircle,
      faLayerGroup,
      faHome,
      faArrowAltCircleDown,
      faStopCircle,
      faPause,
      faExternalLinkSquareAlt,
      faInfoCircle,
      faLink,
      faThumbsUp,
      faThumbtack,
      faVideo,
      faInfo,
      faFolder,
      faClock,
      faLock,
      faArrowAltCircleUp,
      faPhotoVideo,
      faImage,
      faFileImage,
      faTrash,
      faReply,
      faTrashAlt,
      faPlusCircle,
      faEllipsisH,
      faEnvelope,
      faGraduationCap,
      faCalendar,
      faSearch,
      faSun,
      faMoon,
      faStickyNote,
      faCircle,
      faCheckSquare,
      faEye,
      faEyeSlash,
      faArrowUpRightFromSquare,
      faTh,
      faListUl,
      faArrowUp,
      faArrowDown,
      faCopy,
      faExternalLink,
      faLock,
      faTicket,
      faBug,
      faQuestionCircle,
      faRightFromBracket,
      faArrowRotateLeft,
      faEgg,
      faArrowsRotate,
      faRightFromBracket,
      faBan,
      faApple,
      faWindows,
      faLinux
    );
  }
  audio;
}
